  <section class='header'>

    <mat-toolbar color='primary' fxLayoutAlign="space-between">
      <div class="header-line">
        <mat-icon [fontIcon]="iconName"></mat-icon>
        <div class="header-text">
        <ng-content></ng-content>
        </div>
      </div>
      <button class="button-close" mat-raised-button mat-dialog-close>
        <mat-icon class="header-icon">close</mat-icon>
      </button>
    </mat-toolbar>

  </section>
